import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { of } from 'rxjs';
import { AbstractControl, FormControl } from '@angular/forms';
import { TagService } from '../../../../core/services/tag-service.service';

@Component({
  selector: 'kt-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
})
export class TagsComponent implements OnInit {
  selectable = true;
  removable = true;
  highlightTag = false;
  filteredTags;
  @ViewChild('tagInput') entityInput: ElementRef<HTMLInputElement>;
  tagList: any = [];
  tagValue: any;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  @Input() controlObject: FormControl;
  @Input() readOnlyValue;
  @Input() appearance;
  @Input() readOnly = false;
  @Input() value;
  @Input() highlighted;
  @Input() category: 'Entity' | 'Communication' = 'Communication';
  @Input() addOnly = false;
  @Input() autocompleteEntity:
    | 'DOCTOR'
    | 'PATIENT'
    | 'FACILITY'
    | 'CONTACT'
    | 'COMMUNICATION'
    | 'DOCUMENT';
  @Input() canAddComponent = false;

  constructor(private tagService: TagService) {}

  ngOnInit(): void {
    if (this.highlighted) {
      this.highlightTag = true;
    }
    if (this.readOnly) {
      this.selectable = false;
      this.removable = false;
      this.tagList = [...this.readOnlyValue];
    } else {
      this.controlObject.valueChanges.subscribe((value) => {
        if (!value) {
          this.tagList = [];
          this.entityInput.nativeElement.value = '';
        }
      });
    }

    if (this.value) {
      this.value.subscribe((value) => {
        this.tagList = value;
        this.updateModel();
      });
    }
  }

  tagInputChanged(value) {
    if (value && typeof value === 'string' && value.indexOf(' ') > 0) {
      this.entityInput.nativeElement.value = value.replace(' ', '_');
    }
    if (value && !this.addOnly) {
      if (typeof value === 'string')
        this.filteredTags = this.tagService
          .searchTags(this.category, this.autocompleteEntity, value)
          .pipe(
            map((res) =>
              res.data.filter((r) => {
                return !this.tagList.find((e: any) => e.id === r.id);
              }),
            ),
          );
    } else {
      this.filteredTags = of([]);
    }
  }

  getTagDescription(tag) {
    return tag.name;
  }

  remove(entity: string): void {
    const index = this.tagList.indexOf(entity);

    if (index >= 0) {
      this.tagList.splice(index, 1);
    }

    this.updateModel();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tagList.push(event.option.value);
    this.entityInput.nativeElement.value = '';
    this.updateModel();
  }

  add(event: MatChipInputEvent): void {
    const value = event.value;

    if ((value || '').trim()) {
      this.tagList.push({ name: value.trim() });
      this.entityInput.nativeElement.value = '';
    }

    this.updateModel();
  }

  updateModel() {
    this.controlObject.setValue(
      this.tagList.map((tag) => (tag.id ? { id: tag.id } : { name: tag.name })),
    );
  }

  isRequired(): boolean {
    return (
      this.controlObject?.validator && this.controlObject.validator({} as AbstractControl)?.required
    );
  }
}
